angular.module('CarsSaraBo').controller('PriceAndAvailabilityController', ['$scope', '$routeParams', '$q', 'AvailabilityService', 'CompanyService', 'RangeDefinitionService',
    'FleetService', '$http', 'PointOfSaleService', 'AlertEmailService', '$translate', 'HolidayService', 'ContractService', 'GAService', 'DateService',
    '$cookies', 'HotjarService', 'NotificationService', 'SessionService', 'LoadingWheelService', 'RatePriceService',
    function ($scope, $routeParams, $q, availabilityService, companyService, rangeDefinitionService,
              fleetService, $http, pointOfSaleService, alertEmailService, $translate, holidayService, contractService, gaService, dateService,
              $cookies, hotjarService, notificationService, sessionService, loadingWheelService, ratePriceService) {

        function initialize() {
            $scope.searchRequest = {
                from: new Date(),
                rangeDays: "10"
            };
            $scope.rangeDays = ["10", "30", "60"];
            $scope.orderDays = {
                'MONDAY': 1, 'TUESDAY': 2, 'WEDNESDAY': 3, 'THURSDAY': 4, 'FRIDAY': 5, 'SATURDAY': 6, 'SUNDAY': 0
            };
            $scope.validations = {};
            loadCompany();
            $scope.errorMessages = {};
            $scope.period = {};
            $scope.period.from = new Date();
            $scope.monthSet = {};
            $scope.today = new Date();
            $scope.editableAvailability = sessionService.loggedUserAllowed('PERM_AVAILABILITY_EDIT');
            $scope.editablePrice = sessionService.loggedUserAllowed('PERM_PRICE_EDIT');
            $scope.companyOid = $routeParams.oid;
            $scope.getToDate();
            $scope.displayStockModal = false;
            $scope.stockModal = {};
            $scope.stockModalErrorFields = {};
            $scope.displayRateModal = false;
            $scope.rateModal = {};
            $scope.rateModalErrorFields = {};
            $scope.currencyCode = sessionService.session.currencyCode;
            $scope.alertsByPos = {};
            $scope.emptyAlert = '';
            $scope.noAlertsInPos = [];
            $scope.searchErrorFields = {};
            gaService.notify('Autos_precios_y_disponibilidad', 'Page_view_grilla', ['Page_view_grilla']);
            $scope.tablesHasWarnings = false;
            $scope.configTable = {
                position: 0,
                rightLimit: 0,
                extraPixelxMargin: 2
            };
            $scope.arrayPositions = [];
            $scope.arrayrRightLimit = [];
        }

        var MARKUP_NOTIFICATION_CONFIRMED = "Markup_nofitication_confirmed_paa";

        function verifyMarkupMessage(contract) {
            $scope.validations.markupNotification = false;
            var isMarkupCompany = (contract.commissionType === 'MARKUP') ? true : false;
            $scope.validations.isMarkupCompany = isMarkupCompany;
            var makupCookie = $cookies.get(MARKUP_NOTIFICATION_CONFIRMED);
            if (isMarkupCompany && (!makupCookie)) {
                $scope.validations.markupNotification = true;
            }
        }

        function loadCompany() {

            $scope.setProcessesCount(6);
            $scope.pointsOfSale = [];
            $scope.validations.mailAlerts = [];
            alertEmailService.query({companyOid: $routeParams.oid}, function (response) {
                $scope.validations.hasRequiredAlerts = ["RESERVE_MODIFICATION", "CANCELLATION", "RESERVE"];
                _.each(response, function (elem) {
                    $scope.validations.mailAlerts.push(elem.email);
                    _.each(elem.pointOfSaleOids, function (pos) {
                        if (!($scope.alertsByPos.hasOwnProperty(pos))) {
                            $scope.alertsByPos[pos] = [];
                        }
                        for (var i in elem.types) {
                            if ($scope.alertsByPos[pos].indexOf(elem.types[i]) === -1) {
                                $scope.alertsByPos[pos].push(elem.types[i]);
                            }
                        }
                    });
                    _.each(elem.types, function (type) {
                        var index = $scope.validations.hasRequiredAlerts.indexOf(type);
                        if (index > -1) {
                            $scope.validations.hasRequiredAlerts.splice(index, 1);
                        }
                    });
                });
                $scope.notifyProcessComplete();
            });

            pointOfSaleService.resource.query({companyOid: $routeParams.oid}, function (pointsOfSale) {
                pointsOfSale.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
                $scope.pointsOfSale = pointsOfSale;
                $scope.closeDays = {}
                for (var i in pointsOfSale) {
                    $scope.closeDays[pointsOfSale[i].oid] = {};
                    for (var i2 in pointsOfSale[i].businessHours) {
                        $scope.closeDays[pointsOfSale[i].oid][$scope.orderDays[pointsOfSale[i].businessHours[i2].dayOfWeek]] = true;
                    }
                }
                $scope.notifyProcessComplete();
                $scope.validations.pointsOfSale = true;
                $scope.searchRequest.pos = $scope.pointsOfSale[0] ? $scope.pointsOfSale[0].oid : 0;
                $scope.distance = $scope.pointsOfSale[0].distanceMax == 0 ? $scope.pointsOfSale[0].distanceUnit : ("KM_" + $scope.pointsOfSale[0].distanceMax);
            });

            $scope.rangeDefinitions = [];

            rangeDefinitionService.get({companyOid: $routeParams.oid}, function (response) {
                $scope.notifyProcessComplete();
                $scope.rangeDefinitions = response.sort(function compare(a, b) {
                    if (a.startRange < b.startRange)
                        return -1;
                    if (a.startRange > b.startRange)
                        return 1;
                    return 0;
                });
            });

            holidayService.query({companyOid: $routeParams.oid}, function (response) {
                $scope.notifyProcessComplete();
                $scope.holidayMap = createHolidayMap(response);
            });

            var fieldsCar = "oid";
            fleetService.get({companyOid: $routeParams.oid, fields: fieldsCar}, function (response) {
                $scope.notifyProcessComplete();
                $scope.fleet = response;
            });

            var fieldsContract = "oid,commissionType";
            contractService.getAll({companyOid: $routeParams.oid, fields: fieldsContract}, function (response) {
                $scope.notifyProcessComplete();
                $scope.contracts = response;
                verifyMarkupMessage(response[0])
            });

        }

        $scope.updateValidation = function (name, errors) {
            if (!!errors[name]) {
                errors[name] = null;
            }
        };

        function createHolidayMap(holidays) {
            var hm = {};
            holidays.forEach(function (holiday) {
                hm[holiday.date.substring(0, 4) + holiday.date.substring(5, 7) + holiday.date.substring(8, 10)] = 1;
            });
            return hm;
        }

        $scope.getDay = function (date) {
            return $translate.instant('common.week.short.' +
                (new Date(date.substring(0, 4), (date.substring(4, 6) - 1), date.substring(6, 8)).getDay()));
        };

        $scope.getMonth = function (date) {
            return date.substr(4, 2);
        };

        $scope.getDate = function (date) {
            return date.substr(date.length - 2);
        };

        $scope.closeWarning = function () {
            document.getElementById('generalAlert').style.display = "none";
        };

        $scope.columnWithoutAlert = function (data) {

            return noPrice(data) || noStock(data);
        };

        $scope.columnHasWarnings = function (data, parentIndexId, indexId) {

            var unpublished = noPrice(data) || noStock(data);
            var hasWarning = unpublished || $scope.branchClosedOrHoliday(data);

            if(unpublished && parentIndexId != null && indexId != null) {
                $scope.tablesHasWarnings = true;
                document.getElementById('unpublishedLabel-'.concat(parentIndexId)).style.display="block";
            }

            return hasWarning;
        };

        function rightTooltip(tableIndexId, columnIndexId) {
            var elementFullPosition =  document.getElementById('table-'.concat(tableIndexId).concat('column-').concat(columnIndexId)).getBoundingClientRect();
            return elementFullPosition["x"] < 900;
        }

        $scope.branchClosedOrHoliday = function (data) {
            return isClosed(data) || isHoliday(data);
        };

        $scope.getWarningTooltipText = function (data) {
            return $translate.instant('availabilityAndPrice.priceStock.' + getSuffixKeyMessagesMap(data));
        };

        var suffixesMessagesMap = new Map([
            ['NoStock', 'noStock'],
            ['NoPrice', 'noPrice'],
            ['BranchClosed', 'branchClosed'],
            ['NoPriceNoStock', 'noPriceNoStock'],
            ['BranchClosedNoStock', 'branchClosedNoStock'],
            ['BranchClosedNoPrice', 'branchClosedNoPrice'],
            ['BranchClosedNoPriceNoStock', 'branchClosedNoStockNoPrice']
        ]);

        function getSuffixKeyMessagesMap(data) {
            var suffixKey = ''.concat($scope.branchClosedOrHoliday(data) ? 'BranchClosed' : '')
                                .concat(noPrice(data) ? 'NoPrice' : '')
                                .concat(noStock(data) ? 'NoStock' : '');
            return suffixesMessagesMap.get(suffixKey);
        }

        function noStock(data) {
            return data.stock == 0;
        }

        function noPrice(data) {
            return !data.price;
        }

        $scope.setKmDistance = function () {
            var pos = _.find($scope.pointsOfSale, {oid: $scope.searchRequest.pos});
            $scope.distance = pos.distanceMax == 0 ? pos.distanceUnit : ("KM_" + pos.distanceMax);
        };

        $scope.getTableTitle = function (value) {
            var title = "";
            if (value) {
                for (i in value) {
                    var obj = value[i];
                    if (obj) {
                        title = obj.carName + " - " + obj.carBrand + " " + obj.carModel;
                        return title;
                    }
                }
            }
            return title;
        };

        $scope.getAvailabilityList = function (p) {
            if (!p) {
                return null;
            } else {
                var total = "";
                var dot = "\u25CF ";

                total += dot
                    + $translate.instant('common.MORNING') + ": "
                    + (calculateTotal(p.stock, p.bookingsCountAtMorning == undefined ? 0 : p.bookingsCountAtMorning)) + "\n";
                total += dot
                    + $translate.instant('common.AFTERNOON') + ": "
                    + (calculateTotal(p.stock, p.bookingsCountAtAfternoon == undefined ? 0 : p.bookingsCountAtAfternoon)) + "\n";
                total += dot
                    + $translate.instant('common.EVENING') + ": "
                    + (calculateTotal(p.stock, p.bookingsCountAtNight == undefined ? 0 : p.bookingsCountAtNight)) + "\n";

                return total;
            }
        };

        function calculateTotal(availability, bookings) {
            if (bookings >= availability) {
                return 0;
            } else {
                return availability - bookings;
            }
        }

        function isHoliday(carData) {
            return !($scope.holidayMap[carData.dateTime] == undefined);
        }

        function isClosed(p) {
            return ($scope.closeDays[$scope.selectedPos][new Date(p.dateTime.substring(0, 4), (p.dateTime.substring(4, 6) - 1), p.dateTime.substring(6, 8)).getDay()] == undefined);
        }

        $scope.searchAvailability = function () {
            $scope.tablesHasWarnings = false;
            $scope.arrayPositions = [];
            $scope.arrayrRightLimit = [];
            $scope.selectedPos = $scope.searchRequest.pos;
            loadingWheelService.show();
            $scope.priceAvailability = {};
            if (!$scope.period.from) {
                $scope.searchErrorFields['dateFrom'] = true;
                loadingWheelService.hide();
            } else {
                $scope.searchErrorFields = {};
                $scope.searchRequest.from = formatToyyyyMMdd($scope.period.from);
                availabilityService.resource.getAvailability({
                    companyOid: $routeParams.oid,
                    pointOfSaleOid: $scope.searchRequest.pos,
                    dateFrom: $scope.searchRequest.from,
                    range: $scope.searchRequest.rangeDays
                }, function (response) {
                    loadingWheelService.hide();
                    $scope.priceAvailability = response;
                    sortPriceAvailability();
                    var firstKey;
                    for (i in response.priceAndAvailabilities) {
                        firstKey = i;
                        break
                    }
                    var list = response.priceAndAvailabilities[firstKey];
                    if (list) {
                        Object.keys(list).forEach(function (key) {
                            var month = key.substr(4, 2);
                            if ($scope.monthSet[month] == undefined) {
                                $scope.monthSet[key] = month;
                                $scope.monthSet[month] = true;
                            }
                        });
                    }
                });

            }
        };

        function getPosName(selectedPos) {
            _.each($scope.pointsOfSale, function (pos) {
                if (selectedPos == pos.oid) {
                    $scope.emptyAlert = pos.name;
                }
            })
        }

        function checkValidAlerts() {
            var isValid = true;
            var emptyAlert;
            $scope.noAlertsInPos = [];

            if ($scope.alertsByPos.hasOwnProperty($scope.selectedPos)) {
                _.forEach($scope.alertsByPos, function (alerts, pos) {
                    if ($scope.selectedPos == pos) {
                        if (alerts.indexOf('RESERVE') == -1 || alerts.indexOf('CANCELLATION') == -1
                            || alerts.indexOf('RESERVE_MODIFICATION') == -1) {
                            $scope.noAlertsInPos.push(pos);
                            isValid = false;
                        }
                    }
                });
            } else {
                emptyAlert = $scope.selectedPos;
                isValid = false;
            }
            getPosName(emptyAlert);

            return isValid;
        }

        function sortPriceAvailability() {
            Object.keys($scope.priceAvailability.priceAndAvailabilities).forEach(function (key) {
                $scope.priceAvailability.priceAndAvailabilities[key] = getSortedMap($scope.priceAvailability.priceAndAvailabilities[key]);
            });
        }

        function getSortedMap(unordered) {
            var ordered = {};
            Object.keys(unordered).sort().forEach(function (key) {
                ordered[key] = unordered[key];
            });
            return ordered;
        }

        function getNoSingleValueDate(dateFunction) {
            return (dateFunction > 9) ? dateFunction.toString() : '0' + dateFunction.toString();
        }

        function formatToyyyyMMdd(date) {
            return date.getFullYear().toString() + getNoSingleValueDate(date.getMonth() + 1) + getNoSingleValueDate(date.getDate());
        }

        $scope.getToDate = function () {
            var newDate = new Date($scope.period.from);
            newDate.setDate(newDate.getDate() + parseInt($scope.searchRequest.rangeDays));
            $scope.toDate = getNoSingleValueDate(newDate.getDate()) + "/" + getNoSingleValueDate(newDate.getMonth() + 1) + "/" + newDate.getFullYear().toString();
        };

        $scope.getMaxDate = function () {
            var newDate = new Date($scope.period.from);
            newDate.setDate(newDate.getDate() + 730); // Add tow years
            return "'" + newDate.getFullYear().toString() + "-" + getNoSingleValueDate(newDate.getMonth() + 1) + "-" + getNoSingleValueDate(newDate.getDate()) + "'";
        };

        /**********************/

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'ddMMMMyyyy'];
        $scope.format = $scope.formats[4];

        /*************************************/
        /*****VALIDATIONS******/

        /** Stock modification from Modal **/
        $scope.showStockModal = function (priceAndAvailability, fromDate) {
            if ($scope.editableAvailability) {
                var from = moment(fromDate, "YYYYMMDD").toDate();
                $scope.stockModal = {
                    initialStock: priceAndAvailability.stock,
                    period: {
                        from: from
                    },
                    carOid: priceAndAvailability.carOid,
                    contractOid: priceAndAvailability.contractOid
                };
                $scope.displayStockModal = true;
                gaService.notify("Autos_MVP_Notificaciones_Grilla", "Click_en_stock", [calculateAnticipation(from)]);
            }
        };

        $scope.closeStockModal = function () {
            $scope.displayStockModal = false;
            gaService.notify("Autos_MVP_Notificaciones_Grilla", "Cancelar_edición", ["Cancelar"]);
        };

        $scope.saveStockModal = function () {
            if (isValid()) {
                var request = buildAvailabilityModificationRequest($scope.stockModal);
                availabilityService.resource.save({companyOid: $routeParams.oid}, request)
                    .$promise
                    .then(function (response) {
                        trackStockModificationInGA($scope.stockModal);
                        notificationService.displayToast('availability.TITLE', 'availability.confirmationMessage.SUCCESS_SAVE');
                        $scope.searchAvailability();
                        hotjarService.triggerStockSurvey(request);
                    });
                $scope.displayStockModal = false;
            }
        };

        $scope.showRateModal = function (priceAndAvailability, fromDate) {
            $scope.rateModalErrorFields = {};
            var from = moment(fromDate, "YYYYMMDD").toDate();
            $scope.rateModal = {
                rates: {},
                period: {
                    from: from
                },
                carOid: priceAndAvailability.carOid,
            };

            if (!!priceAndAvailability.price) {
                for (var i in $scope.rangeDefinitions) {
                    $scope.rateModal.rates[$scope.rangeDefinitions[i].oid] = priceAndAvailability.price[$scope.rangeDefinitions[i].name];
                }
            }
            $scope.displayRateModal = true;
            gaService.notify("Autos_MVP_Notificaciones_Grilla", "Click_en_precio", [calculateAnticipation(from)]);
        };

        $scope.closeRateModal = function () {
            $scope.displayRateModal = false;
            gaService.notify("Autos_MVP_Notificaciones_Grilla", "Cancelar_edición_precio", ["Cancelar"]);
        };

        $scope.saveRateModal = function () {
            if (isValidRate()) {
                var rates = $scope.rateModal;
                ratePriceService.save(getCarPrice(rates), $routeParams.oid, getPosRate($scope.searchRequest.pos)
                    , getRatePeriod(rates))
                    .then(function (response) {
                        trackRateModificationInGA(rates);
                        notificationService.displayToast('rate.TITLE', 'rate.confirmationMessage.SUCCESS_SAVE');
                        $scope.searchAvailability();
                    }, function (error) {
                        gaService.notify("submit_form", "ERROR");
                    });
                $scope.displayRateModal = false;
            }
        };

        function getPosRate(pos) {
            var response = {};
            response[pos] = {checked: true};
            return response;
        }

        function getRatePeriod(rateModal) {
            return {
                from: rateModal.period.from,
                to: rateModal.period.to
            }
        }

        function getCarPrice(rateModal) {
            var rate = {};
            rate[rateModal.carOid] = {};
            for (var i in rateModal.rates) {
                if (!!rateModal.rates[i]) {
                    rate[rateModal.carOid][i] = rateModal.rates[i];
                }
            }
            return rate;
        }

        function isValidRate() {
            var isValid = true;

            if (!hasAnyValue($scope.rateModal.rates)) {
                isValid = false;
                $scope.rateModalErrorFields['newRate'] = true;
            }

            var period = $scope.rateModal.period;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.rateModalErrorFields['newRatePeriod'] = true;
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.rateModalErrorFields['newRatePeriod'] = true;
            }
            if (!checkValidAlerts()) {
                isValid = alertEmailsValidation();
            }
            return isValid;
        }

        function alertEmailsValidation() {
            var errorMessageList = [];
            $scope.rateModalErrorFields['pointsOfSale'] = "input-error";

            if ($scope.noAlertsInPos.length > 0) {
                errorMessageList.push({
                    code: "alert.NO_ALERTS_REGISTERED_TITLE_priceAndAvailability",
                    params: ["alertEmail.RESERVE", "alertEmail.CANCELLATION", "alertEmail.MODIFICATIONS", "alert.NO_VALID_MAIL_ACTION_priceAndAvailability"]
                });
            }
            if ($scope.emptyAlert) {
                errorMessageList.push({
                    code: "alert.NO_VALID_MAIL_POS_priceAndAvailability",
                    params: [$scope.emptyAlert, "alert.NO_VALID_MAIL_ACTION_priceAndAvailability"]
                });
            }
            gaService.notify("errores_validacion", ["alertemail:required"]);

            for (var i in errorMessageList) {
                notificationService.notifyErrorByCodeWithMessageAndErrorList(errorMessageList[i].code, errorMessageList[i].params);
            }

            return false;
        }

        function hasAnyValue(rates) {
            var hasAny = false;
            for (var i in rates) {
                if (rates[i] != undefined && rates[i] !== '' && rates[i] !== null) {
                    hasAny = true;
                    break;
                }
            }
            return hasAny;
        }

        function isValid() {
            var isValid = true;
            var errorMessageList = [];
            if ($scope.stockModal.initialStock == undefined || $scope.stockModal.initialStock === '') {
                isValid = false;
                $scope.stockModalErrorFields['newStock'] = true;
            }

            var period = $scope.stockModal.period;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.stockModalErrorFields['newStockPeriod'] = true;
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.stockModalErrorFields['newStockPeriod'] = true;
            }

            if (!checkValidAlerts()) {
                isValid = alertEmailsValidation();
            }

            return isValid;
        }

        function buildAvailabilityModificationRequest(stockModal) {
            var cars = {};
            cars[stockModal.carOid] = stockModal.initialStock;
            return {
                cars: cars,
                companyOid: $routeParams.oid,
                contractOid: stockModal.contractOid,
                daysOfWeek: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],
                period: {
                    from: moment(stockModal.period.from).format("YYYYMMDD"),
                    to: moment(stockModal.period.to).format("YYYYMMDD")
                },
                pointsOfSale: [$scope.searchRequest.pos]
            };
        }

        function trackStockModificationInGA(stockModal) {
            var fromDate = moment(stockModal.period.from).startOf('day');
            var toDate = moment(stockModal.period.to).startOf('day');
            var stock = stockModal.initialStock;
            var anticipation = calculateAnticipation(stockModal.period.from);
            var amountOfModifiedDays = toDate.diff(fromDate, 'days');
            gaService.notify("Autos_MVP_Notificaciones_Grilla", "Guardar_stock", [stock, anticipation, amountOfModifiedDays]);
        }

        function trackRateModificationInGA(rateInfo) {
            var fromDate = moment(rateInfo.period.from).startOf('day');
            var toDate = moment(rateInfo.period.to).startOf('day');
            var carId = rateInfo.carOid;
            var anticipation = calculateAnticipation(rateInfo.period.from);
            var amountOfModifiedDays = toDate.diff(fromDate, 'days');
            gaService.notify("Autos_MVP_Notificaciones_Grilla", "Guardar_rate", [anticipation, amountOfModifiedDays]);
        }

        function calculateAnticipation(fromDate) {
            var from = moment(fromDate).startOf('day');
            var now = moment().startOf('day');
            return from.diff(now, 'days');
        }

        $scope.onMouseOver = function(event, parentIndexId, indexId, value){
            if(rightTooltip(parentIndexId, indexId)) {
                document.getElementById('spanTooltip-table'.concat(parentIndexId)
                                                            .concat('-col')
                                                            .concat(indexId))
                                        .className = "eva-3-tooltip -right-inline -white -sm-full";
            } else {
                document.getElementById('spanTooltip-table'.concat(parentIndexId)
                                                            .concat('-col')
                                                            .concat(indexId))
                                        .className = "eva-3-tooltip -left-inline -white -sm-full";
            }

            setCellAlertColor(value, parentIndexId, indexId,"background-color 0.5s", "#FFE066");
        };

        $scope.onMouseLeave = function(event, parentIndexId, indexId, value){
            setCellAlertColor(value, parentIndexId, indexId,"background-color 1s", "#FFF");
        };

        function setCellAlertColor(value, parentIndexId, indexId, styleTransition, styleBackgroundColor) {
            if(noStock(value)) {
                document.getElementById('tdStock-row'.concat(parentIndexId)
                    .concat('-col')
                    .concat(indexId)).style.transition = styleTransition;
                document.getElementById('tdStock-row'.concat(parentIndexId)
                    .concat('-col')
                    .concat(indexId)).style.backgroundColor = styleBackgroundColor;
            }

            if(noPrice(value)) {
                var elementList = document.getElementsByClassName('tdPrice-row'.concat(parentIndexId).concat('-col').concat(indexId));
                for (var i = 0; i < elementList.length; i++) {
                    elementList[i].style.transition = styleTransition;
                    elementList[i].style.backgroundColor = styleBackgroundColor;
                }
            }
        }

        var extraPixelxMargin,
            containerWidth,
            scrollable,
            addPosition,
            tableWidth,
            finalPosition;

        $scope.scrollTableNext = function(indexId){
            extraPixelxMargin = 195;
            containerWidth = document.getElementById('container-'.concat(indexId)).offsetWidth;
            scrollable = document.getElementById('scrollTable-'.concat(indexId));
            addPosition = containerWidth / 2;
            tableWidth = scrollable.offsetWidth + extraPixelxMargin;
            finalPosition = tableWidth - containerWidth;

            $scope.arrayrRightLimit[indexId] = $scope.arrayPositions[indexId] < finalPosition ? 0 : 1;
            if (containerWidth < tableWidth && $scope.arrayPositions[indexId] < finalPosition) {
                $scope.arrayPositions[indexId] = $scope.arrayPositions[indexId] + addPosition;
                if ($scope.arrayPositions[indexId] + addPosition > finalPosition) {
                    scrollable.style.transform = "translateX("+(-finalPosition)+"px)";
                    $scope.arrayrRightLimit[indexId] = 1;
                } else {
                    scrollable.style.transform = "translateX("+(-$scope.arrayPositions[indexId])+"px)";
                }
            }

            var firstColumnWidth = document.getElementById('tableHead-'.concat(indexId)).getBoundingClientRect()["width"];
            document.getElementById('leftScrollNav-'.concat(indexId)).style.marginLeft = (firstColumnWidth + 2).toString().concat('px');
        };

        $scope.scrollTablePrev = function(indexId){
            extraPixelxMargin = 195;
            containerWidth = document.getElementById('container-'.concat(indexId)).offsetWidth;
            scrollable = document.getElementById('scrollTable-'.concat(indexId));
            addPosition = containerWidth / 2;
            tableWidth = scrollable.offsetWidth + extraPixelxMargin;
            finalPosition = 0;

            if (containerWidth < tableWidth && $scope.arrayPositions[indexId] > finalPosition) {
                $scope.arrayPositions[indexId] = $scope.arrayPositions[indexId] - addPosition;
                if ($scope.arrayPositions[indexId] - addPosition < finalPosition) {
                    scrollable.style.transform = "translateX("+(-finalPosition)+"px)";
                    $scope.arrayrRightLimit[indexId] = 0;
                    $scope.arrayPositions[indexId] = 0;
                } else {
                    scrollable.style.transform = "translateX("+(-$scope.arrayPositions[indexId])+"px)";
                    $scope.arrayrRightLimit[indexId] = 0;
                }
            }
        };

        initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/price-and-availability/priceAndAvailability_controller.js
// module id = 827
// module chunks = 3